import { render, staticRenderFns } from "./TicoursesSurveyQuestions.vue?vue&type=template&id=048c7347"
import script from "./TicoursesSurveyQuestions.vue?vue&type=script&lang=js"
export * from "./TicoursesSurveyQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports